module.exports = __webpack_public_path__ + "static/media/Approved.dcb5331d.svg";